.container {
  display: flex;
}

.search {
  flex: 1;
}

.assetsList {
  max-height: 330px;
  overflow: auto;
  margin: 0 calc(-1 * var(--space-xs));
}

.hint {
  display: block;
  margin-top: var(--space-xs);
  color: var(--color-accent-1);
  font-size: 0.8em;
}

.latest {
  flex-basis: 40%;
  margin-left: var(--space-m);
  padding-left: var(--space-m);
  border-left: 1px solid var(--color-svp-grey);
  display: block;
}
